import { Col, Modal, Row } from "@/utils/bootstrap";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SvgModalClose from "@/app/components/lib/SvgModalClose";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  agree: boolean;
  reason: string;
}

const DisbledReplyReasonModal: React.FC<Props> = ({
  show,
  setShow,
  reason,
  agree,
}) => {
  const t = useTranslation();
  return (
    <Modal
      centered
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="messagebox-dialog"
      contentClassName="messagebox-cart-disabled"
    >
      <div className="messagebox-closeicon">
        <SvgModalClose onClick={() => setShow(false)} />
      </div>
      {/* <div className="messagebox-title">{t.terms_conditions}</div> */}
      <div className="messagebox-message" style={{ textAlign: "center" }}>
        {!agree ? t.you_should_agree_to_terms_conditions : reason}
      </div>
      <Row className="m-0 w-100">
        <Col className="p-0">
          <div className="w-100">
            <CustomButton
              onClick={() => {
                setShow(false);
              }}
              type={BtnTypes.primary}
              size={BtnSizes.large}
              radius={BtnRadius.small}
              fullWidth
            >
              {t.ok}
            </CustomButton>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default DisbledReplyReasonModal;
